import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { usePreview } from "react-dnd-multi-backend";
// On desktop the HTML5 backend renders a native drag image, but the touch
// backend renders nothing — so a player dragged on a touch device would be
// invisible mid-drag. This badge follows the finger to show what's being moved.
// Rendered once at the app root; it only displays while a touch drag is active.
export var FormationDragPreview = function () {
    var _a;
    var preview = usePreview();
    if (!preview.display) {
        return null;
    }
    var item = preview.item, style = preview.style;
    var label = (_a = item.player.squadNumber) !== null && _a !== void 0 ? _a : item.player.lastName.slice(0, 3);
    return (_jsx(Box, { style: style, sx: { pointerEvents: "none", zIndex: 2000 }, children: _jsx(Box, { sx: {
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: "#1d4ed8",
                color: "#ffffff",
                border: "2px solid rgba(15, 23, 42, 0.55)",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.35)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800,
                fontSize: "0.85rem",
                transform: "translate(-50%, -50%)",
            }, children: label }) }));
};
